import { atom } from 'recoil';

import { ICommand } from 'client-types/*';

export type AttachmentSource = 'upload' | 'drive';

export interface IAttachment {
  id: string;
  serverId?: string;
  name: string;
  size: number;
  type: string;
  uploadProgress?: number;
  uploaded?: boolean;
  // Local object URL, images only — so the tray shows the picture itself
  // instead of a generic file icon. Revoked when the attachment goes away.
  previewUrl?: string;
  // Where the file came from, so the chip can show its provider's mark.
  source?: AttachmentSource;
  // Set on placeholder chips only: what is being done to the file right now
  // ("Reading the document…"). Its presence is what makes a chip a
  // placeholder, so it must be cleared, not just emptied.
  stage?: string;
  cancel?: () => void;
  remove?: () => void;
}

export const attachmentsState = atom<IAttachment[]>({
  key: 'Attachments',
  default: []
});

export const persistentCommandState = atom<ICommand | undefined>({
  key: 'PersistentCommand',
  default: undefined
});

export const starterCardsState = atom<any[]>({
  key: 'StarterCards',
  default: []
});
